import json2csv from "json2csv";
import * as R from "ramda";

import * as a from "./action";
import * as s from "./selector";
// import { sendMessage } from "../Notifications";
import withActions from "../../utils/redux/withActions";
// import { startLoading, stopLoading } from "../Suspense";

const { setSortBy, setSortDirection } = a;

const noHTML = R.pickBy(
  (value, key) => !/\<\w+(\w+|=|"|'|\s)*\>.*\<\/\w+\>/.test(value)
);

const boundedActions = withActions({
  // sendMessage,
  // startLoading,
  // stopLoading,
  setSortBy,
  setSortDirection,
});

function makeDownloadFile({ filter, sortBy, SortDirection, dataName }) {
  const sortSection = sortBy ? `-${sortBy}-${SortDirection}` : "";

  const tag = (filter.length > 0 ? `-${filter}` : "") + sortSection;
  return `${dataName}${tag}.csv`
    .replace(/\(\s+/g, "(")
    .replace(/\s+\)/g, ")")
    .replace(/not/g, " not ")
    .replace(/&/g, " and ")
    .replace(/\|/g, " or ")
    .replace(/\s+/g, "_")
    .toLowerCase();
}

export const downloadCSV = (props) =>
  boundedActions(async ({ getState }, bda) => {
    // bda.startLoading();

    let tableRows = s.tableRows(getState(), props);
    tableRows.shift(); // REMOVE THE TITLE ROW;
    if (tableRows.length === 0) return;

    const filter = s.filter(getState(), props);
    const SortDirection = s.SortDirection(getState(), props);
    const sortBy = s.sortBy(getState(), props);
    const columnOrder = s.columnOrder(getState(), props);
    const inflateRow = s.inflateRow(columnOrder);
    const processFlatRow = R.pipe(inflateRow, noHTML);
    tableRows = tableRows.map(processFlatRow);

    const csv = json2csv({ data: tableRows });

    const $a = document.createElement("a");
    $a.href = `data:text/csv;charset=utf-16,${encodeURI(csv)}`;
    $a.target = "_blank";
    $a.download = makeDownloadFile({
      filter,
      sortBy,
      SortDirection,
      dataName: props.dataName,
    });
    // NOTE: You need to append the tag to the DOM so all the browsers
    //       fire the default action. (e.g. Firefox)
    document.body.appendChild($a);
    $a.click();
    document.body.removeChild($a);

    // bda.sendMessage(`Starting to download your CSV! 🎉`);
    // bda.stopLoading();
  });

export const handleSort = (props, payload) =>
  boundedActions(async ({ getState }, bda) => {
    const { dataName } = props;
    const { sortBy } = payload;
    const sortDirection = s.sortDirection(getState(), props);
    const lastSortBy = s.sortBy(getState(), props);

    if (lastSortBy === sortBy) {
      bda.setSortDirection(dataName, sortDirection * -1);
    } else {
      bda.setSortBy(dataName, sortBy);
      bda.setSortDirection(dataName, 1);
    }
  });
